var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:['icon', _vm.size],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.15 3.2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M34.55,0H1.6C.72,0,0,.72,0,1.6s.72,1.6,1.6,1.6h32.95c.88,0,1.6-.72,1.6-1.6s-.72-1.6-1.6-1.6Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }